import React from "react";
import { Send, Ban, Trash2, Download, Printer, Pencil, History } from "lucide-react";
import { downloadSigned, printSigned } from "@/components/contracts/contractUtils";
import { toast } from "sonner";

export default function ContractActions({ c, onSend, onVoid, onDelete, onEdit, editing }) {
  const run = (fn) => fn().catch(() => toast.error("Couldn't fetch the signed PDF"));
  return (
    <div className="surface-card p-5 space-y-2" data-testid="contract-actions">
      <div className="label-eyebrow mb-1">▮ ACTIONS</div>
      {c.can_download && (
        <div className="grid grid-cols-2 gap-2">
          <button onClick={() => run(() => downloadSigned(c.id, c.title))} className="btn-primary text-xs justify-center" data-testid="contract-download-btn"><Download size={12} /> Download PDF</button>
          <button onClick={() => run(() => printSigned(c.id))} className="btn-ghost inline-flex items-center gap-1.5 text-xs justify-center" data-testid="contract-print-btn"><Printer size={12} /> Print</button>
        </div>
      )}
      {["draft", "sent"].includes(c.status) && !editing && (
        <button onClick={onEdit} className="btn-ghost inline-flex items-center gap-1.5 text-xs w-full justify-center" data-testid="contract-edit-fields-btn"><Pencil size={12} /> Edit Fields</button>
      )}
      {c.status === "draft" && <button onClick={onSend} className="btn-primary text-xs w-full justify-center" data-testid="contract-send-btn"><Send size={12} /> Send for Signature</button>}
      {c.status === "sent" && <button onClick={onSend} className="btn-ghost inline-flex items-center gap-1.5 text-xs w-full justify-center" data-testid="contract-resend-btn"><Send size={12} /> Re-send Discord Notices</button>}
      {c.status !== "voided" && <button onClick={onVoid} className="btn-ghost inline-flex items-center gap-1.5 text-xs w-full justify-center text-[var(--ff-red)]" data-testid="contract-void-btn"><Ban size={12} /> Void Contract</button>}
      {["draft", "voided"].includes(c.status) && <button onClick={onDelete} className="btn-ghost inline-flex items-center gap-1.5 text-xs w-full justify-center text-[var(--ff-red)]" data-testid="contract-delete-btn"><Trash2 size={12} /> Delete</button>}
      {c.audit?.length > 0 && (
        <details className="pt-2" data-testid="contract-audit">
          <summary className="cursor-pointer font-mono-ui text-[0.65rem] uppercase tracking-[0.15em] text-[var(--ff-text-dim)] inline-flex items-center gap-1"><History size={11} /> Audit Trail ({c.audit.length})</summary>
          <ul className="mt-2 space-y-1 max-h-56 overflow-y-auto">
            {c.audit.slice().reverse().map((a, i) => (
              <li key={i} className="text-[0.7rem] leading-snug"><span className="text-[var(--ff-text-dim)]">{new Date(a.at).toLocaleString()}</span> · {a.actor} — {a.action}</li>
            ))}
          </ul>
        </details>
      )}
    </div>
  );
}
